<template>
  <div ref="item" class="nt-video nt-video--background">
    <picture>
      <source media="(max-width:767px)" :srcset="`${getCoverUrlWithSize(800)}`">
      <img ref="cover" v-show="!playing && loadedCover" :src="`${getCoverUrlWithSize(1900)}`" @load="onLoadCover">
    </picture>
    <video :id="id" v-show="playing" ref="video" 
      preload="metadata" muted="true"
      webkit-playsinline="true" playsinline="true"
      width="100%" height="100%" 
      frameborder="0" @error="onError" loop>
      <source :src="videoUrl" type="video/mp4">
      Your browser does not support the video tag.
    </video>
  </div>
</template>

<script>
  export default {
    name: 'NtVideoBackground',
    props: {
      videoUrl: {
        type: String,
        default: null
      },
      id: {
        type: String,
        default: 'video'
      },
      cover: {
        type: String,
        default: '/'
      }
    },
    methods: {
      // This funcion is necessary to resolve the following problem:
      // https://niobiumtech.cbmm.local/-/media/NiobiumTech/Images/banner-main.jpg?extension=avif%2cwebp&hash=B43D8A003F63289A0B77933A19F0F54697FF314D?mw=1900
      // The old component version was inserting a query parameter no mather if the URL already had it.
      // As the component needs a specific size, we're checking if the mw parameter already exists in the url and change it as needed
      getCoverUrlWithSize(size) {
        const hasQueryString = () => this.cover.indexOf('?') > 0
        const hasMaxWidth = () => this.cover.indexOf('mw=') > 0
        const replaceMaxWidth = () => this.cover.replace(/mw=(\d)*(&)?/g, `mw=${size}&`)
        const addMaxWidth = () => {
          if (hasMaxWidth()) {
            return replaceMaxWidth()
          }
          return `${this.cover}${hasQueryString() ? '&' : '?'}mw=${size}`
        }
        return addMaxWidth()
      },
      play() {
        if (!this.playing && !this.error) {
          this.player.play()
          this.playing = true
          this.played = true
        }
      },
      onError() {
        this.playing = false
        this.error = true
      },
      resizeVideo() {
        if (this.windowRatio() < this.videoRatio) {
          this.player.style.width = 'auto'
          this.player.style.height = '100%'
        } else {
          this.player.style.height = 'auto'
          this.player.style.width = '100%'
        }
      },
      resizeCover() {
        if (this.windowRatio() < this.coverRatio()) {
          this.$refs.cover.style.width = 'auto'
          this.$refs.cover.style.height = '100%'
        } else {
          this.$refs.cover.style.height = 'auto'
          this.$refs.cover.style.width = '100%'
        }
      },
      onLoadCover() {
        this.resizeCover()
        this.loadedCover = true
      },
      windowRatio() {
        return this.$refs.item.offsetWidth / this.$refs.item.offsetHeight
      },
      coverRatio() {
        return this.$refs.cover.width / this.$refs.cover.height
      }
    },
    data() {
      return {
        player: null,
        playing: false,
        played: false,
        error: false,
        loadedVideo: false,
        loadedCover: false,
        videoRatio: 0
      }
    },
    created() {
      this.$parent.$on('stop', () => {
        this.pause()
      })
    },
    mounted() {
      if (!this.cover.length || !this.videoUrl.length || this.errorMessage) {
        this.onError()
      }
      this.player = this.$refs.video
      this.errorState = this.player.readyState
      this.parent = this.$parent

      this.player.addEventListener('error', this.onError)
      this.player.addEventListener('abort', this.onError)
      this.player.addEventListener('pause', () => {
        this.playing = false
      })
      window.addEventListener('resize', () => {
        this.resizeVideo()
        this.resizeCover()
      })
      this.player.oncanplay = () => {
        this.videoRatio = this.player.videoWidth / this.player.videoHeight
        this.resizeVideo()
        this.loadedVideo = true
        this.player.play()
      }
      this.player.onplaying = () => {
        this.playing = true
      }
      this.player.onpause = () => {
        this.player.play()
      }
      this.player.load()
    }
  }
</script>
